import { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import ProfitCostTemplateList from "./FixedHeaderList";
import styles from "../Settings.module.scss";
import EditFixedFeeHeader from "./EditFixedFeeHeader";
import { addFixedFeeHeader } from "services/fixedfeeService";

const ProfitCostTemplate = ({ onClose, open }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeForm = () => {
    setIsFormOpen(false);
  };

  useEffect(() => {
    if (onClose === false) {
      closeForm();
    }
  }, [onClose]);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      // Ensure allowedApps is properly formatted and filter out any empty values
      const allowedApps = Array.isArray(formData.allowedApps)
        ? formData.allowedApps.filter(Boolean).join(",")
        : formData.allowedApps;

      const res = await addFixedFeeHeader({
        ...formData,
        allowedApps,
        type: "ProfitCost",
      });
      if (res.success) {
        toast.success("Template added successfully");
        closeForm();
      }
    } catch (error) {
      toast.error("Error occurred while adding template");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column>">
        <div className="d-flex ms-auto me-5">
          <Button
            className={`common-btn mt-5 me-5 p-2 py-3 ${styles.button}`}
            style={{ minWidth: "120px" }}
            onClick={() => {
              setIsFormOpen(true);
              open?.();
            }}
          >
            Add Template
          </Button>
        </div>
      </div>

      <div className={`row mx-auto mt-5 ${styles["branches-grid"]}`}>
        <ProfitCostTemplateList />
      </div>

      {isFormOpen && (
        <EditFixedFeeHeader
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  );
};

export default ProfitCostTemplate;
